import styled from 'styled-components'

import { useSvgHref } from '../../svgHrefContext'

import * as icon from '../Icon'

const SYMBOL_ID = 'icon-share-def'

FullShare.filename = SYMBOL_ID
export function FullShare(props: icon.SpecificIconProps): React.ReactElement {
    return (
        <icon.Icon {...props} name="share">
            <defs>
                <g id={SYMBOL_ID}>
                    <path d="M14 5a4 4 0 111.158 2.815L9.85 10.912a4.003 4.003 0 010 2.175l5.311 3.095a4 4 0 11-1.01 1.726l-5.309-3.094a4 4 0 110-5.63L14.15 6.09A4.004 4.004 0 0114 5zm4-2a2 2 0 100 4 2 2 0 000-4zM6 10a2 2 0 100 4 2 2 0 000-4zm10 9a2 2 0 114 0 2 2 0 01-4 0z" />
                </g>
            </defs>
            <use href={`#${SYMBOL_ID}`} />
        </icon.Icon>
    )
}

export const Share = styled(function Share(
    props: icon.SpecificIconProps
): React.ReactElement {
    const href = useSvgHref(SYMBOL_ID)
    return (
        <icon.Icon {...props} name="share">
            <use href={href} />
        </icon.Icon>
    )
})``
